import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Merge class names with clsx semantics, then de-duplicate conflicting
 * Tailwind utilities (last one wins). The single class-composition helper
 * for every @praesto/ui-kit component.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
